<template>
  <v-app v-resize="onResize">
    <v-navigation-drawer
    :mini-variant="miniVariant"
    v-model="showDrawer"
    width="200"
    fixed
    app>
      <v-list>
        <v-list-tile
        :value="true"
        v-for="item in filteredMenuItems"
        :key="item.title"
        @click="gotoPath(item.path)">
          <v-list-tile-action>
            <v-icon light v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar
    color="white"
    app>
      <v-toolbar-side-icon @click="toggleMenu"></v-toolbar-side-icon>
      <img src="@/assets/logo_small.png" alt="ICABody" class="logo">
      <v-toolbar-title>{{ routeTitle }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <ToolbarAuthButtons />
      <UserIcon />
    </v-toolbar>

    <v-content>
      <router-view/>
    </v-content>
    <!-- <v-footer></v-footer> -->
  </v-app>
</template>

<script>
import UserIcon from '@/components/auth/UserIcon.vue'
import ToolbarAuthButtons from '@/components/auth/ToolbarAuthButtons.vue'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      debug: false,

      miniVariant: false,
      showDrawer: null,
      menuItems: [
        {
          title: 'Login',
          icon: 'account_circle',
          path: '/login',
          requireUnauth: true
        },
        {
          title: 'Register new account',
          icon: 'face',
          path: '/register',
          requireUnauth: true
        },
        {
          title: 'Projects',
          icon: 'class',
          path: '/projects',
          requireAuth: true
        },
        {
          title: 'Instructions PDF',
          icon: 'picture_as_pdf',
          path: 'https://www.icabody.com/wp-content/uploads/2021/04/ICABODY_User_2021.pdf'
        },
        {
          title: 'Go to website',
          icon: 'ondemand_video',
          path: 'https://www.icabody.com'
        }
      ]
    }
  },
  watch: {
    miniVariant(to, from) {
      if (this.debug) console.log(this.$options.name+'.watch miniVariant to',to,'from:',from);
    },
    showDrawer(to, from) {
      if (this.debug) console.log(this.$options.name+'.watch showDrawer to',to,'from:',from);
    },
    // '$route'(to, from) {
    //   console.log(this.$options.name+'.watch *** route to',to,'from:',from);
    // }
  },
  beforeRouteEnter(to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!
    console.log('App.beforeRouteEnter *** route to',to,'from:',from);
    next();
  },
  beforeRouteUpdate(to, from, next) {
    // called when the route that renders this component has changed,
    // but this component is reused in the new route.
    // For example, for a route with dynamic params `/foo/:id`, when we
    // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
    // will be reused, and this hook will be called when that happens.
    // has access to `this` component instance.
    console.log('App.beforeRouteUpdate *** route to',to,'from:',from);
    next();
  },
  beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    console.log('App.beforeRouteLeave *** route to',to,'from:',from);
    next();
  },
  computed: {
    ...mapState('auth', {
      user: state => state.user
    }),

    ...mapState('util', {
      isMobile: state => state.isMobile // map `this.isMobile` to `this.$store.state.util.isMobile`
    }),

    filteredMenuItems () {
      return this.menuItems.filter((item) => {
        if ((!this.user && item.requireAuth) || (this.user && item.requireUnauth)) return false
        if (item.requireAdmin) return (this.user ? this.user.admin : false)
        return true
        // return !item.requireAdmin || this.user.admin
      })
    },
    // routeParams() {
    //   if (this.debug) console.log(this.$options.name+'.computed *** routeParams $route',this.$route,'this.$router:',this.$router);
    //   return this.$route.params;
    // },
    // routeObj() {
    //   if (this.debug) console.log(this.$options.name+'.computed *** routeObj $route',this.$route,'this.$router:',this.$router);
    //   return this.$route;
    // },
    routeTitle () {
      // if (this.debug) console.log(this.$options.name+'.computed *** routeTitle $route',this.$route,'this.$router:',this.$router);
      return this.$route.meta.title;
    }
  },

  components: {
    UserIcon,
    ToolbarAuthButtons
  },

  beforeCreate() {
    if (this.debug) console.log(this.$options.name+'.beforeCreate()');
  },
  created() {
    if (this.debug) console.log(this.$options.name+'.created()');
  },
  beforeMount() {
    if (this.debug) console.log(this.$options.name+'.beforeMount()');
  },
  mounted() {
    if (this.debug) console.log(this.$options.name+'.mounted()');
  },
  beforeUpdate() {
    if (this.debug) console.log(this.$options.name+'.beforeUpdate()');
  },
  updated() {
    if (this.debug) console.log(this.$options.name+'.updated()');
  },
  beforeDestroy() {
    if (this.debug) console.log(this.$options.name+'.beforeDestroy()');
  },
  destroyed() {
    if (this.debug) console.log(this.$options.name+'.destroyed()');
  },

  methods: {
    ...mapMutations('util', [
      'setMobile' // map `this.setMobile()` to `this.$store.dispatch('util/setMobile')`
    ]),

    closeMenu (event) {
      if (this.debug) console.log(this.$options.name+'.closeMenu() tagName:',event.target.tagName,'event:',event,'this:',this);
      this.showDrawer = false;
    },

    toggleMenu (event) {
      if (this.debug) console.log(this.$options.name+'.toggleMenu() tagName:',event.target.tagName,'event:',event,'this:',this);
      this.showDrawer = !this.showDrawer
    },

    gotoPath (path) {
      if (this.debug) console.log(this.$options.name+'.gotoPath() path:',path);
      if (path.toLowerCase().startsWith("http")) {
        window.open(path, '_blank').focus();
      }
      else {
        this.$router.push(path);
      }
    },

    onResize () {
      if (this.debug) console.log(this.$options.name+'.onResize() window.innerWidth:',window.innerWidth);
      let isMobile = (window.innerWidth < 769)
      if (isMobile !== this.isMobile) {
        if (this.debug) console.log(this.$options.name+'.onResize() setMobile:',isMobile);
        this.setMobile(isMobile)
      }
    }
  }
}
</script>

<style>  /* "scoped" attribute limit the CSS to this component only */
body,
.application,
.title {
	font-family: 'Titillium Web', sans-serif !important;
}
</style>
<style scoped>  /* "scoped" attribute limit the CSS to this component only */
.v-navigation-drawer {
  padding-top: 64px;
  background-color: #0B3B5E;
}
.v-toolbar {
  z-index: 3;
  padding-left: 0 !important;
}
.v-content {
  background-color: #FFFFFF;
}
</style>